import { DATE_TIME_FORMAT, DEFAULT_DATE_FORMAT } from '@shared/utils'
import { Locale } from 'antd/es/locale'
import roRo from 'antd/locale/ro_RO'
import ruRU from 'antd/locale/ru_RU'

import 'dayjs/locale/ro'
import 'dayjs/locale/ru'

type Props = {
  label: string
  value: 'ro' | 'ru'
  systemValue: Locale
  icon: string
}

if (roRo.DatePicker?.lang) {
  roRo.DatePicker.lang.fieldDateFormat = DEFAULT_DATE_FORMAT
  roRo.DatePicker.lang.fieldDateTimeFormat = DATE_TIME_FORMAT
}

if (ruRU.DatePicker?.lang) {
  ruRU.DatePicker.lang.fieldDateFormat = DEFAULT_DATE_FORMAT
  ruRU.DatePicker.lang.fieldDateTimeFormat = DATE_TIME_FORMAT
}

export const allLangs: Props[] = [
  {
    label: 'Română',
    value: 'ro',
    systemValue: roRo,
    icon: 'ro.svg'
  },
  {
    label: 'Русский',
    value: 'ru',
    systemValue: ruRU,
    icon: 'ru.svg'
  }
]

export const defaultLang = allLangs[0]
